import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import {TeacherList} from "../../../../components/Admin/TeacherCmp";
import { TeacherForm } from "../../../../components/Admin/TeacherCmp/TeacherForm";
import "./Page_Institution_Teacher.scss";

export function Page_Institution_Teacher() {
  const { user,accessToken } = useAuth();
 
  // Estados para los modales y recargas
 
  const [showModalDocente, setShowModalDocente] = useState(false);
  const onOpenCloseModalDocente = () => setShowModalDocente((prevState) => !prevState);
  const [reloadDocente, setReloadDocente] = useState(false);
  const onReloadDocente = () => setReloadDocente((prevState) => !prevState);
  const [reload, setReload] = useState(false); // Estado para forzar la recarga de la lista de escenas
  const onReload = () => setReload((prevState) => !prevState); // Función para forzar la recarga de las escenas

  return (
    <div className="institution-profile-page">
      {/* Sección con botones */}
      <div className="buttons-container">
     
        <Button
          primary
          onClick={onOpenCloseModalDocente}
        >
          Nuevo Docente
        </Button>
      </div>
      <div> <h1>LISTADO DE DOCENTES</h1>
      <TeacherList 
      user={user} 
      accessToken={accessToken}
      reload={reload} 
      onReload={onReload} /></div>

      {/* Modales */}
      <BasicModal
        show={showModalDocente}
        close={onOpenCloseModalDocente}
        title="Crear Nuevo Docente"
      >
        <TeacherForm 
        user={user} 
        show={showModalDocente}
        onClose={onOpenCloseModalDocente} 
        reloadDocente={reloadDocente} 
        onReload={onReloadDocente} 
        />
      </BasicModal>
    </div>
   
  );
}

